import ApiService from "services/ApiService";
import ApiRequestService from "services/ApiRequestService";

export const EmployeeReviewTypesService = {
    getEmployeeReviewOptions() {
        return ApiRequestService.get("employee", "Options/EmployeeReviews");
    },
    getReviewType(reviewTypeId) {
        return ApiRequestService.get("employee", `EmployeeReviewTypes/${reviewTypeId}`);
    },
    createReviewType(reviewType) {
        return ApiRequestService.post("employee", "EmployeeReviewTypes", reviewType);
    },
    updateReviewType(reviewType, reviewTypeId) {
        return ApiRequestService.put("employee", `EmployeeReviewTypes/${reviewTypeId}`, reviewType);
    },
    getReviewTypeChangeLog(reviewTypeId, pageSize, pageNumber, startDate, endDate) {
        return ApiRequestService.get(
            "employee",
            `Changelog/ReviewType/${reviewTypeId}?resultCount=${pageSize}&pageNumber=${pageNumber}&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`
        );
    },
    searchReviewTypes(pageSize, pageNumber, sortField, sortDirection, searchTerm, filters) {
        const searchObject = {
            requestCount: pageSize,
            pageNumber: pageNumber,
            searchTerm: searchTerm ?? "",
            sortField: sortField,
            sortDirection: sortDirection,
            filters: filters ?? [],
        };

        return new Promise((resolve, reject) => {
            ApiService.post(`/employee/EmployeeReviewTypes/Search`, searchObject).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
    deleteReviewType(reviewTypeId) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`/employee/EmployeeReviewTypes/${reviewTypeId}`).then(
                (result) => {
                    resolve(result.data);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
};
